import { render, staticRenderFns } from "./searchPage.vue?vue&type=template&id=2d70d769&scoped=true"
import script from "./searchPage.vue?vue&type=script&lang=js"
export * from "./searchPage.vue?vue&type=script&lang=js"
import style0 from "./searchPage.vue?vue&type=style&index=0&id=2d70d769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70d769",
  null
  
)

export default component.exports